"use client"

import { datadogRum } from '@datadog/browser-rum';

if (process.env.NODE_ENV == "production" && typeof window !== "undefined") {
  datadogRum.init({
    applicationId: '4d704eb2-5e96-4d60-8980-1988c59c7e0d',
    clientToken: 'pub2016b65fb18fa794d9b5c3875940f4b5',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'embedded-app',
    env: 'prod',
    allowedTracingUrls: [
      (url) => url.startsWith("https://api.verticalinsure.com")
    ],
    // Specify a version number to identify the deployed version of your application in Datadog 
    version: process.env.NEXT_PUBLIC_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    usePartitionedCrossSiteSessionCookie: true
  });
}

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
